import ResponsePermission from '../../data/ResponsePermissionJSON';

const state = {
    data: ResponsePermission.Controls,
    sponsorPermission: ResponsePermission.SponsorPermission
};

// getters
const getters = {
    getPermissionJsonById: (state) => (ControlId) => {
        return state.data.find(x => x.ControlId === ControlId.ControlId);
    },
    getPermissionJsonByUser: (state) => (user) => {
        var SponsorType = GetSponsorTypeByUser(user.user);
        return state.sponsorPermission.find(x => x.Type === SponsorType);
    }
};

function GetSponsorTypeByUser(user){
    if(user){
        if(user.eBoothGrade != "" && user.eBoothGrade != null){
            return user.eBoothGrade;
        } else if(user.isMember > 0){
            return "Member"
        } else if(user.isExhibitor > 0){
            return "Guest"
        } else {
            return ""
        }
    } 
}

// mutations
const mutations = {
};

// actions
const actions = {
};

export default {
    namespaced: true,
	state,
	getters,
	actions,
	mutations
};